import { API_ENDPOINT } from "@/constants/appConstants";
import { getHttpMethod } from "@/helpers/getHttpMethod";
import { useProfileSectionData } from "@/hooks";
import {
  AI_SUMMARY,
  PROFILE_QUERY_KEY,
  PROFILE_STATS_QUERY_KEY,
  VALIDATE_PROFILE_QUERY_KEY,
} from "@/lib/queryKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ActionType, ErrorResponse } from "@/components/profile/types";

import { EducationData } from "./types";

// export const getEducations = (): UseQueryResult<EducationData, Error> => {
//   return useQuery({
//     queryKey: [EDUCATION_QUERY_KEY],
//     queryFn: () => profileAPI<EducationData>("educations"),
//   });
// };

export const getEducations = () => {
  return useProfileSectionData<EducationData>("educationDetailSection");
};

export const useUpdateEducation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ data, action }: { data: any; action: ActionType }) => {
      const method = getHttpMethod(action);
      const response = await fetch(
        API_ENDPOINT(window.location.host).middleware.educations,
        {
          method,
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        },
      );

      if (!response.ok) {
        const errorData = (await response.json()) as ErrorResponse;
        throw new Error(
          errorData.error.message.errorMessage || "Something went wrong",
        );
      }

      return await response.json();
    },
    onSuccess: () => {
      // queryClient.invalidateQueries({ queryKey: [EDUCATION_QUERY_KEY] });
      // // to update ai summary
      queryClient.invalidateQueries({ queryKey: [AI_SUMMARY] });
      queryClient.invalidateQueries({ queryKey: [PROFILE_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [PROFILE_STATS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [VALIDATE_PROFILE_QUERY_KEY] });
    },
  });
};
